<template>
  <a-card title="用户数据统计">
    <a-space >
    </a-space>
      <table class="stats-table">
        <legend>昨日作品相关数据</legend>
        <tr>
          <th >项目</th><th>数据</th><th>公式</th><th>说明</th>
        </tr>
        <tr>
          <td>新用户使用次数 1</td><td> {{ stats_data.new_user_generate_counts["1"] }} 
            （占比: {{ (stats_data.new_user_generate_counts["1"] * 100 / stats_data.user_today_count).toFixed(2) }}%）
          </td><td></td><td></td>
        </tr>
        <tr>
          <td>新用户使用次数 2</td><td> {{ stats_data.new_user_generate_counts["2"] }} 
            （占比: {{ (stats_data.new_user_generate_counts["2"] * 100 / stats_data.user_today_count).toFixed(2) }}%）
          </td>
          <td></td><td></td>
        </tr>
        <tr>
          <td>新用户使用次数 3</td><td> {{ stats_data.new_user_generate_counts["3"] }} 
            （占比: {{ (stats_data.new_user_generate_counts["3"] * 100 / stats_data.user_today_count).toFixed(2) }}%）
          </td>
          <td></td><td></td>
        </tr>
        <tr>
          <td>新用户使用次数 4</td><td> {{ stats_data.new_user_generate_counts["4"] }} 
            （占比: {{ (stats_data.new_user_generate_counts["4"] * 100 / stats_data.user_today_count).toFixed(2) }}%）
          </td>
          <td></td><td></td>
        </tr>
        <tr>
          <td>新用户使用次数 5</td><td> {{ stats_data.new_user_generate_counts["5"] }} 
            （占比: {{ (stats_data.new_user_generate_counts["5"] * 100 / stats_data.user_today_count).toFixed(2) }}%）
          </td>
          <td></td><td></td>
        </tr>
        <tr>
          <td>新用户使用次数 6</td><td> {{ stats_data.new_user_generate_counts["6"] }} 
            （占比: {{ (stats_data.new_user_generate_counts["6"] * 100 / stats_data.user_today_count).toFixed(2) }}%）
          </td>
          <td></td><td></td>
        </tr>
        <tr>
          <td>新用户使用次数 &gt; 6</td><td> {{ stats_data.new_user_generate_counts[">6"] }} 
            （占比: {{ (stats_data.new_user_generate_counts[">6"] * 100 / stats_data.user_today_count).toFixed(2) }}%）
          </td>
          <td></td><td>基数为当日新增</td>
        </tr>
        <tr>
          <td>新用户无人创作</td><td> {{ stats_data.user_today_count - stats_data.new_user_generate_total }} </td><td></td><td>包括创作失败的情况</td>
        </tr>
        <tr>
          <td>创作人数</td><td> {{ stats_data.generate_counts["uv"] }} </td><td></td><td>包括创作失败的情况</td>
        </tr>
        <tr>
          <td>创作数量</td><td> {{ stats_data.generate_counts["total"] }} 
            (人均创作数量: {{ (stats_data.generate_counts["total"] / stats_data.generate_counts["uv"]).toFixed(2) }} )
          </td>
          <td></td>
          <td>包括创作失败的情况</td>
        </tr>
        <tr>
          <td>创作失败数量</td><td>
            {{ stats_data.generate_counts["failed"] }} 
            (失败率:  {{ ((stats_data.generate_counts["failed"]) * 100 / stats_data.generate_counts["total"]).toFixed(2) }}% )
          </td><td>
            {{ stats_data.generate_counts["failed"] }} / {{ stats_data.generate_counts["total"] }} 
          </td><td></td>
        </tr>
        <tr>
          <td>图片审核未通过</td><td>
            {{ stats_data.generate_counts["audit_failed"] }} 
            (审核未通过率:  {{ ((stats_data.generate_counts["audit_failed"]) * 100 / stats_data.generate_counts["total"]).toFixed(2) }}% )
          </td><td>
            {{ stats_data.generate_counts["audit_failed"] }} / {{ stats_data.generate_counts["total"] }} 
          </td><td></td>
        </tr>
        <tr>
          <td>创作执行失败数量</td><td>
            {{ stats_data.generate_counts["failed"] - stats_data.generate_counts["audit_failed"]  }} 
            (失败率:  {{ ((stats_data.generate_counts["failed"] - stats_data.generate_counts["audit_failed"] ) * 100 / stats_data.generate_counts["total"]).toFixed(2) }}% )
          </td><td>
            {{ stats_data.generate_counts["failed"] - stats_data.generate_counts["audit_failed"]  }} / {{ stats_data.generate_counts["total"] }} 
          </td><td></td>
        </tr>
        <tr>
          <td>创作离开数量</td><td>
            {{ stats_data.generate_counts["leave"] }} 
            (离开率:  {{ ((stats_data.generate_counts["leave"] ) * 100 / stats_data.generate_counts["total"]).toFixed(2) }}% )
          </td><td>
            {{  stats_data.generate_counts["leave"] }} / {{ stats_data.generate_counts["total"] }} 
          </td><td></td>
        </tr>
        <tr>
          <td>终身会员创作量</td><td>
            {{ stats_data.life_user["new_generate_count"] }} 
            (人均创作:  {{ ((stats_data.life_user["new_generate_count"] ) * 100 / stats_data.life_user["count"]).toFixed(2) }}% )
          </td><td>
            {{  stats_data.life_user["new_generate_count"] }} / {{ stats_data.life_user["count"] }} 
          </td><td></td>
        </tr>
        <tr>
          <td>生成作品数量</td><td>
            {{ stats_data.download_counts["total"] }} 
          </td>
          <td></td>
          <td>不包含失败的任务</td>
        </tr>
        <tr>
          <td>下载图片数量</td><td>
            {{ stats_data.download_counts["download_count"] }} 
            (下载率:  {{ ((stats_data.download_counts["download_count"] ) * 100 / stats_data.download_counts["total"] ).toFixed(2) }}% )
          </td><td>
            {{ stats_data.download_counts["download_count"] }} / {{  stats_data.download_counts["total"]  }}
          </td><td></td>
        </tr>
      </table>
    
  </a-card>

  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    // SearchOutlined
  },
  data(){
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return {
      today_dt: today.toLocaleDateString(),
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      stats_data:{
        "life_user": {
          "count":0,
          "new_generate_count": 0,
        },

        "download_counts": {},
        "generate_counts": {},
        "new_user_generate_counts": {},
        "new_user_generate_total": 0,
      },
       formSearch: {
        region: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      const rspTotal = await request.get('/api/stats/yesterday', {})
      this.loading = false
      for(let k in rspTotal.data) {
        this.stats_data[k] = rspTotal.data[k]
      }
      const rspGeneration = await request.get('/api/stats/generation', {})
      this.loading = false
      for(let k in rspGeneration.data) {
        this.stats_data[k] = rspGeneration.data[k]
      }
      for (let k in this.stats_data.new_user_generate_counts) {
        this.stats_data.new_user_generate_total += this.stats_data.new_user_generate_counts[k]
      }
    },
  
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.stats-table {
  
}
.stats-table td {
  border: 1px solid #999;
  padding: 4px 8px;
}
</style>